<template>
    <div
        class="d-flex align-center w-100 bundle-template-line-item-title"
    >
        <span>{{ line.name }}</span>
        <v-spacer></v-spacer>
        <v-icon
            v-if="isInvalid"
            :icon="mdiAlert"
            color="error"
        ></v-icon>
        <ul
            v-else-if="valueLabel.size"
            class="
                ma-0
                list-style-none
                list-comma-sep
                font-size-8
                text-none
                font-weight-regular
                d-flex
                flex-grow-0
                justify-end
            "
        >
            <li
                v-for="[key, val] in valueLabel"
                :key="`bundle-title-value-${key}`"
                class="text-truncate"
            >
                {{ val }}
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
    import type {
        GenericObject,
        BundleTemplateLine
    } from '~/types';
    import { mdiAlert } from '@mdi/js';

    const props = defineProps<{
        modelValue: Nilish<GenericObject<Nullable<string>>[]>;
        line: BundleTemplateLine;
        isInvalid?: boolean;
    }>();

    const valueLabel = ref<Map<string, string>>(new Map());
    const unWatchProps = watch(
        [
            () => props.modelValue,
            () => props.line
        ],
        ([ newModel, newLine ]) => {
            if (newLine && newModel?.length) {
                valueLabel.value.clear();
                const values = newModel.flatMap(Object.values);
                newLine.optionsData?.forEach(
                    (opt) => {
                        const found = opt.values.find((val) => values.includes(val.uid));

                        if (found) {
                            valueLabel.value.set(found.uid, found.name);
                        }
                    }
                );
            }
        },
        {
            immediate: true,
            deep: true
        }
    );

    onBeforeUnmount(() => {
        unWatchProps();
    });
</script>

<style lang="scss">
.bundle-template-line-item-title {
    li {
        max-width: 20ch;
        display: inline-block;
    }
}
</style>
